module.exports = __webpack_public_path__ + "static/media/openness-spectrum.863fbece.png";